import { render } from "./ScanPage.vue?vue&type=template&id=7b134052"
import script from "./ScanPage.vue?vue&type=script&lang=js"
export * from "./ScanPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__